import { Quill } from 'react-quill-new';

const BlockEmbed = Quill.import('blots/block/embed');

// This is the CustomVideo class from your ChapterEditor.js
class CustomVideo extends BlockEmbed {
  static blotName = 'customVideo';
  static tagName = 'video';

  static create(value) {
    const node = super.create();
    node.setAttribute('controls', '');
    node.setAttribute('controlsList', 'nodownload'); // To disable download button
    node.setAttribute('src', value);
    node.setAttribute('width', '100%'); // For responsiveness
    node.setAttribute('playsinline', 'true'); // Important for iOS inline playback
    node.setAttribute('preload', 'metadata'); // Good for loading video length and first frame
    
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

// A single function to register all your custom formats
export const registerQuillCustoms = () => {
  // Check if it's already registered to prevent errors on hot-reloading
  if (!Quill.imports['formats/customVideo']) {
    Quill.register(CustomVideo);
  }
  // You can register other custom blots here in the future
};